import { isTenantScoped } from '../utils/permissions';
import { getPlatformAdminSteps } from './tracks/platformAdminTour';
import { getPartnerAdminSteps } from './tracks/partnerAdminTour';
import { getTenantAdminSteps } from './tracks/tenantAdminTour';
import { getTenantUserSteps } from './tracks/tenantUserTour';
import { appCreatorSteps } from './tracks/appCreatorTour';
import { supportAgentSteps } from './tracks/supportAgentTour';

export const resolveTourTrack = (currentUser, tenantFeatures) => {
  if (!currentUser) return null;

  const role = currentUser.roleId;

  // Support Agents / Support Admin
  if (['r8', 'r9', 'r10', 'r5'].includes(role)) {
    return { key: 'global_v1_support', steps: supportAgentSteps };
  }

  // App Creator
  if (role === 'r6') {
    return { key: 'global_v1_creator', steps: appCreatorSteps };
  }

  // Partner Admin
  if (role === 'r3') {
    return { key: 'global_v1_partner', steps: getPartnerAdminSteps(tenantFeatures) };
  }

  // Platform Admins
  if (['r1', 'r2'].includes(role)) {
    return { key: 'global_v1_platform', steps: getPlatformAdminSteps() };
  }

  // Tenant Admin
  if (role === 'r4') {
    return { key: 'global_v1_tenant_admin', steps: getTenantAdminSteps(tenantFeatures) };
  }

  // Tenant User (r7) OR any Custom Tenant Role (scoped to tenant)
  if (isTenantScoped(currentUser)) {
    return { key: 'global_v1_tenant_user', steps: getTenantUserSteps(tenantFeatures) };
  }

  return null;
};
